angular
  .module('bb.my_business')
  .factory('myBusinessService', myBusinessService);

myBusinessService.$inject = ['$resource', '$location'];

function myBusinessService($resource, $location) {
  const MyBusiness = $resource('/my_business');
  const actions = $resource('/my_business/tiles_content');

  function getActionRequired() {
    return actions.get().$promise;
  }

  function viewListing(id) {
    $location.path(`listing/${id}/view`);
  }

  function configureListing(id) {
    $location.path(`listing/${id}/appointments/config`);
  }

  function viewDocuments(id) {
    $location.path(`listing/${id}/documents`);
  }

  function confirmAppointment(id) {
    $location.path(`appointments/${id}/status/confirm`);
  }

  function denyAppointment(id) {
    $location.path(`appointments/${id}/status/deny`);
  }

  function viewAppointmentDetails(id) {
    $location.path(`/appointments/${id}/action`);
  }

  function getMyBusiness() {
    return MyBusiness.get().$promise;
  }

  return {
    getMyBusiness,
    getActionRequired,
    viewListing,
    configureListing,
    viewDocuments,
    confirmAppointment,
    denyAppointment,
    viewAppointmentDetails,
  };
}

export {};
